import { render, staticRenderFns } from "./Bedrooms.vue?vue&type=template&id=a012c254&"
import script from "./Bedrooms.vue?vue&type=script&lang=ts&"
export * from "./Bedrooms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports